'use client';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Svg = ({ children }) => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2.2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);

// Our own icons: crisp at any size and colour-matched to the toast type by CSS.
const ICONS = {
  success: <Svg><circle cx="12" cy="12" r="9.5" /><path d="m7.8 12.4 2.8 2.8 5.6-5.8" /></Svg>,
  error: <Svg><circle cx="12" cy="12" r="9.5" /><path d="m9 9 6 6M15 9l-6 6" /></Svg>,
  warning: <Svg><path d="M12 3.2 2.6 19.4a1 1 0 0 0 .9 1.5h17a1 1 0 0 0 .9-1.5Z" /><path d="M12 9.5v4.2M12 17h.01" /></Svg>,
  info: <Svg><circle cx="12" cy="12" r="9.5" /><path d="M12 11v5.5M12 7.8h.01" /></Svg>,
};

const icon = ({ type, isLoading }) => {
  if (isLoading) return <span className="ui-toast-spinner" aria-hidden="true" />;
  return ICONS[type] || null;
};

/**
 * The single toast outlet for the app (mounted once in the root layout).
 * Visual styling lives in styles/polish.scss under "Toasts".
 */
export default function AppToaster() {
  return (
    <ToastContainer
      position="top-right"
      autoClose={4000}
      limit={4}
      newestOnTop
      closeOnClick
      pauseOnFocusLoss={false}
      pauseOnHover
      draggable
      draggablePercent={40}
      theme="light"
      icon={icon}
      toastClassName="ui-toast"
      bodyClassName="ui-toast-body"
      progressClassName="ui-toast-progress"
      closeButton={({ closeToast }) => (
        <button type="button" className="ui-toast-close" onClick={closeToast} aria-label="Dismiss notification">
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
            <path d="M6 6l12 12M18 6 6 18" />
          </svg>
        </button>
      )}
    />
  );
}
